module.exports = __webpack_public_path__ + "img/billing_verification_report.b590a131.svg";